import { Result } from 'antd-mobile';
import React, { ReactElement } from 'react';
import PageState from '../data-models/page-state';

function ErrorPage(props: { code: PageState }): ReactElement {
    const { code } = props;
    let message = '';
    switch (code) {
        case PageState.unauthorized:
            message = 'Oops...请重新登录。';
            break;
        case PageState.noPermission:
            message = 'Oops...你暂时还没有权限访问这个页面。';
            break;
        case PageState.notFound:
            message = 'Oops...您访问的页面不存在。';
            break;
        default:
            message = 'Oops...发生未知错误';
    }
    return <Result title={code} message={message} />;
}

export default ErrorPage;
